































































import { VueCustom } from 'vue-custom';
import { PopupName } from 'types';
import { HINTS_URL } from 'config';
import { mapGetters } from 'stores';
import * as POPUPS from 'constants/popups';

import EventsManager from 'managers/events.manager';

import AnimationFinalEncyclopedia from 'components/animations/final/encyclopedia.vue';

import IconClear from 'assets/icons/clear.svg';
import IconClose from 'assets/icons/close.svg';
import IconEncyclopedia from 'assets/icons/encyclopedia.svg';
import IconHints from 'assets/icons/hints.svg';
import IconRevert from 'assets/icons/revert.svg';
import IconSettings from 'assets/icons/settings.svg';

import MenuButton from './button.vue';

export default VueCustom.extend({
  name: 'menu-custom',
  components: {
    AnimationFinalEncyclopedia,
    MenuButton,
    IconClear,
    IconClose,
    IconEncyclopedia,
    IconHints,
    IconRevert,
    IconSettings,
  },
  computed: {
    ...mapGetters([
      'isPopupWithNameActive',
      'encyclopediaTimestamp',
      'workspaceRevertable',
      'progressSince',
    ]),
    HINTS_URL() {
      return HINTS_URL;
    },
    newInEncyclopediaCount(): number {
      return this.progressSince(this.encyclopediaTimestamp).length;
    },
    isSettingsActive(): boolean {
      return this.isPopupWithNameActive(POPUPS.SETTINGS);
    },
    isEncyclopediaActive(): boolean {
      return this.isPopupWithNameActive(POPUPS.ENCYCLOPEDIA);
    },
  },
  methods: {
    onClearRevert() {
      this.$store.dispatch('workspaceClearRevertStart');
    },
    toggleSettings() {
      if (!this.isPopupWithNameActive(POPUPS.SETTINGS)) {
        EventsManager.emit('SETTINGS_SHOW');
      } else {
        EventsManager.emit('SETTINGS_HIDE');
      }

      this.toggle(POPUPS.SETTINGS);
    },
    toggleEncyclopedia() {
      this.toggle(POPUPS.ENCYCLOPEDIA);
    },
    toggleStore() {
      this.toggle(POPUPS.STORE);
    },
    toggleHints() {
      // disable icons if sync merge popup is open
      if (this.isPopupWithNameActive(POPUPS.SYNC)) return;

      window.open(HINTS_URL, '_blank');
      this.onHintsClick();
    },
    onHintsClick() {
      EventsManager.emit('HINTS_CLICKED');
    },
    toggle(name: PopupName) {
      // disable icons if sync merge popup is open
      if (this.isPopupWithNameActive(POPUPS.SYNC)) return;

      this.$store.dispatch('popupToggle', name);
    },
  },
});
